import React from "react";

const DatepickerArrowsIcon = ({ className }) => {
  return (
    <svg
      width="38px"
      height="29px"
      viewBox="0 0 38 29"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group-5">
        <g id="enter-arrow" transform="translate(0 13)">
          <path
            d="M21.675 1.275L21.675 6.375L4.845 6.375L9.435 1.785L7.65 0L0 7.65L7.65 15.3L9.435 13.515L4.845 8.925L24.225 8.925L24.225 1.275L21.675 1.275Z"
            transform="translate(0 0.0125)"
            id="Path"
            fill="#22b645"
            stroke="none"
          />
        </g>
        <g id="enter-arrow" transform="matrix(-1 0 0 -1 38 16)">
          <path
            d="M21.675 1.275L21.675 6.375L4.845 6.375L9.435 1.785L7.65 0L0 7.65L7.65 15.3L9.435 13.515L4.845 8.925L24.225 8.925L24.225 1.275L21.675 1.275Z"
            transform="translate(0 0.0125)"
            id="Path"
            fill="#ff4300"
            stroke="none"
          />
        </g>
      </g>
    </svg>
  );
};

export default DatepickerArrowsIcon;
